(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("CNUI"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "CNUI"], factory);
	else if(typeof exports === 'object')
		exports["cn-cpo-talent-nav"] = factory(require("React"), require("CNUI"));
	else
		root["cn-cpo-talent-nav"] = factory(root["React"], root["CNUI"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 